


// import { motion, useScroll, useTransform } from 'framer-motion'
// import { useState, useEffect, useRef } from 'react'
// import { ChevronLeft, ChevronRight, ArrowRight, ArrowLeft, CheckCircle2 } from 'lucide-react'
// import { useNavigate } from 'react-router-dom'
// import { useTranslation } from 'react-i18next'
// import LoadingIndicator from './LoadingIndicator'
// import '../styles/glassmorphism.css'

// // adjust the path if your assets folder is different
// import AlKondaLogo from '../assets/al-konda-logo--647x500.png'

// const ServicePageLayout = ({
//     title,
//     subtitle,
//     description,
//     backgroundImages,
//     services,
//     capabilities,
//     stats,
//     workflow,
//     heroSlides,
//     introText,
//     children
// }) => {
//     const { t, i18n } = useTranslation()
//     const isRTL = i18n.language === 'ar' || i18n.language === 'ku'
//     const [currentImageIndex, setCurrentImageIndex] = useState(0)
//     const [imagesLoaded, setImagesLoaded] = useState(false)
//     const navigate = useNavigate()
//     const containerRef = useRef(null)
//     const { scrollYProgress } = useScroll({
//         target: containerRef,
//         offset: ['start start', 'end end']
//     })

//     const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%'])

//     // Preload images for smoother transitions with timeout
//     useEffect(() => {
//         const imagePromises = backgroundImages.map(src => {
//             return new Promise(resolve => {
//                 const img = new Image()
//                 img.src = src
//                 img.onload = resolve
//                 img.onerror = resolve
//                 setTimeout(() => resolve(), 3000)
//             })
//         })

//         const loadingTimeout = setTimeout(() => {
//             setImagesLoaded(true)
//         }, 2000)

//         Promise.all(imagePromises)
//             .then(() => {
//                 clearTimeout(loadingTimeout)
//                 setImagesLoaded(true)
//             })
//             .catch(() => {
//                 clearTimeout(loadingTimeout)
//                 setImagesLoaded(true)
//             })

//         return () => clearTimeout(loadingTimeout)
//     }, [backgroundImages])

//     useEffect(() => {
//         const interval = setInterval(() => {
//             setCurrentImageIndex(prev => (prev + 1) % backgroundImages.length)
//         }, 5000)
//         return () => clearInterval(interval)
//     }, [backgroundImages.length])

//     const nextImage = () => {
//         setCurrentImageIndex(prev => (prev + 1) % backgroundImages.length)
//     }

//     const prevImage = () => {
//         setCurrentImageIndex(prev => (prev - 1 + backgroundImages.length) % backgroundImages.length)
//     }

//     return (
//         <div
//             ref={containerRef}
//             className="relative min-h-screen text-white overflow-x-hidden"
//         >
//             {/* Loading Overlay */}
//             {!imagesLoaded && (
//                 <motion.div
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     exit={{ opacity: 0 }}
//                     className="fixed inset-0 z-50 bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center backdrop-blur-sm"
//                 >
//                     <LoadingIndicator size="large" showText={true} />
//                 </motion.div>
//             )}

//             {/* Dynamic Background Layer - takes effect from current hero image */}
//             <div className="fixed inset-0 -z-10 bg-black">
//                 <motion.div
//                     key={currentImageIndex}
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ duration: 1.5 }}
//                     className="absolute inset-0 bg-cover bg-center"
//                     style={{
//                         backgroundImage: `url(${backgroundImages[currentImageIndex]})`,
//                         filter: 'blur(20px) brightness(0.4)',
//                         transform: 'scale(1.1)'
//                     }}
//                 />
//                 {/* Overlays for proper contrast and color neutrality */}
//                 <div className="absolute inset-0 bg-black/40" />
//                 <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black" />
//             </div>

//             {/* Hero Section */}
//             <section className="relative h-[100dvh] min-h-[600px] w-full overflow-hidden z-10">
//                 {/* Background Slider */}
//                 <motion.div style={{ y }} className="absolute inset-0 w-full h-full">
//                     {backgroundImages.map((image, index) => (
//                         <motion.div
//                             key={index}
//                             className="absolute inset-0 bg-cover bg-center bg-no-repeat"
//                             style={{ backgroundImage: `url(${image})` }}
//                             initial={{ opacity: 0, scale: 1.1 }}
//                             animate={{
//                                 opacity: index === currentImageIndex ? 1 : 0,
//                                 scale: index === currentImageIndex ? 1 : 1.1
//                             }}
//                             transition={{ duration: 1.5, ease: 'easeInOut' }}
//                         />
//                     ))}
//                     <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />
//                     <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
//                 </motion.div>

//                 {/* Hero Content */}
//                 <div className="relative z-20 h-full flex flex-col justify-between">
//                     {/* Top Content */}
//                     <div className="flex-1 flex items-start pt-32 sm:pt-32 lg:pt-36">
//                         <div className="w-full px-6 sm:px-8 lg:px-12 max-w-7xl mx-auto">
//                             <motion.div
//                                 initial={{ opacity: 0, x: -50 }}
//                                 animate={{ opacity: imagesLoaded ? 1 : 0, x: imagesLoaded ? 0 : -50 }}
//                                 transition={{ duration: 0.8, delay: 0.2 }}
//                                 className="space-y-6 sm:space-y-8 w-full"
//                             >
//                                 {/* Text Content */}
//                                 <div className="space-y-6 sm:space-y-8">
//                                     {heroSlides ? (
//                                         <motion.div
//                                             key={currentImageIndex}
//                                             initial={{ opacity: 0, y: 30 }}
//                                             animate={{ opacity: 1, y: 0 }}
//                                             exit={{ opacity: 0, y: -30 }}
//                                             transition={{ duration: 0.8, ease: "easeOut" }}
//                                             className="space-y-4 sm:space-y-4"
//                                         >
//                                             <div className="text-white/80 text-sm min-[390px]:text-base min-[430px]:text-lg sm:text-base font-semibold tracking-[0.15em] uppercase">
//                                                 {heroSlides[currentImageIndex].subtitle || subtitle}
//                                             </div>
//                                             <h1 className="text-3xl min-[390px]:text-4xl min-[430px]:text-5xl sm:text-5xl md:text-6xl lg:text-6xl xl:text-7xl font-medium text-white leading-[0.95] tracking-tight">
//                                                 {heroSlides[currentImageIndex].title || title}
//                                             </h1>
//                                         </motion.div>
//                                     ) : (
//                                         <div className="space-y-4 sm:space-y-4">
//                                             <div className="text-white/80 text-sm min-[390px]:text-base min-[430px]:text-lg sm:text-base font-semibold tracking-[0.15em] uppercase">
//                                                 {subtitle}
//                                             </div>
//                                             <h1 className="text-3xl min-[390px]:text-4xl min-[430px]:text-5xl sm:text-5xl md:text-6xl lg:text-6xl xl:text-7xl font-medium text-white leading-[0.95] tracking-tight">
//                                                 {title}
//                                             </h1>
//                                         </div>
//                                     )}

//                                     <p className="text-base min-[390px]:text-lg min-[430px]:text-xl sm:text-xl md:text-xl lg:text-xl text-white/90 font-normal leading-relaxed max-w-3xl">
//                                         {heroSlides ? heroSlides[currentImageIndex].description : description}
//                                     </p>
//                                 </div>
//                             </motion.div>
//                         </div>
//                     </div>

//                     {/* Bottom Content */}
//                     <div className="pb-16 sm:pb-16 lg:pb-20">
//                         <div className="w-full px-6 sm:px-8 lg:px-12 max-w-7xl mx-auto">
//                             <motion.div
//                                 key={heroSlides ? currentImageIndex : 0}
//                                 initial={{ opacity: 0, y: 30 }}
//                                 animate={{ opacity: 1, y: 0 }}
//                                 exit={{ opacity: 0, y: -30 }}
//                                 transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
//                                 className="space-y-6 sm:space-y-6"
//                             >
//                                 {/* CTA Buttons */}
//                                 <div className="flex flex-wrap gap-4">
//                                     <button
//                                         onClick={() => document.getElementById('content').scrollIntoView({ behavior: 'smooth' })}
//                                         className="group bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] text-white px-8 py-4 sm:px-8 sm:py-4 rounded-full font-medium hover:bg-white/10 transition-all duration-300 flex items-center gap-3 sm:gap-3 text-base min-[390px]:text-lg min-[430px]:text-xl sm:text-base min-h-[56px] sm:min-h-[56px] touch-manipulation"
//                                     >
//                                         {t('buttons.exploreServices')}
//                                         {isRTL ? (
//                                             <ArrowLeft className="w-5 h-5 min-[390px]:w-6 min-[390px]:h-6 min-[430px]:w-7 min-[430px]:h-7 sm:w-5 sm:h-5 group-hover:-translate-x-1 transition-transform duration-300" />
//                                         ) : (
//                                             <ArrowRight className="w-5 h-5 min-[390px]:w-6 min-[390px]:h-6 min-[430px]:w-7 min-[430px]:h-7 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform duration-300" />
//                                         )}
//                                     </button>
//                                     <button
//                                         onClick={() => navigate('/services')}
//                                         className="bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] text-white px-8 py-4 sm:px-8 sm:py-4 rounded-full font-medium hover:bg-white/10 transition-all duration-300 text-base min-[390px]:text-lg min-[430px]:text-xl sm:text-base min-h-[56px] sm:min-h-[56px] touch-manipulation"
//                                     >
//                                         {t('buttons.allServices')}
//                                     </button>
//                                 </div>
//                             </motion.div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Slider Controls */}
//                 <div className={`absolute bottom-12 z-30 flex gap-4 ${isRTL ? 'left-12' : 'right-12'}`}>
//                     <button
//                         onClick={isRTL ? nextImage : prevImage}
//                         className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center hover:bg-white/20 transition-colors"
//                     >
//                         {isRTL ? <ChevronRight className="w-6 h-6" /> : <ChevronLeft className="w-6 h-6" />}
//                     </button>
//                     <button
//                         onClick={isRTL ? prevImage : nextImage}
//                         className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center hover:bg-white/20 transition-colors"
//                     >
//                         {isRTL ? <ChevronLeft className="w-6 h-6" /> : <ChevronRight className="w-6 h-6" />}
//                     </button>
//                 </div>

//                 {/* Progress Bar */}
//                 <div className="absolute bottom-0 left-0 w-full h-1 bg-white/10">
//                     <motion.div
//                         className="h-full bg-white"
//                         initial={{ width: '0%' }}
//                         animate={{ width: '100%' }}
//                         transition={{ duration: 5, repeat: Infinity, ease: 'linear', key: currentImageIndex }}
//                     />
//                 </div>
//             </section>

//             {/* Main Content Section */}
//             <section id="content" className="relative pt-24 pb-32 px-6 z-10">
//                 <div className="container mx-auto">
//                     {/* Stats Grid */}
//                     {stats && (
//                         <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-24 border-b border-white/10 pb-12">
//                             {stats.map((stat, index) => (
//                                 <motion.div
//                                     key={index}
//                                     initial={{ opacity: 0, y: 20 }}
//                                     whileInView={{ opacity: 1, y: 0 }}
//                                     viewport={{ once: true }}
//                                     transition={{ delay: index * 0.1 }}
//                                     className="text-center md:text-left"
//                                 >
//                                     <div className="text-4xl md:text-5xl font-light mb-2">{stat.value}</div>
//                                     <div className="text-white/60 text-sm uppercase tracking-wider">{stat.label}</div>
//                                 </motion.div>
//                             ))}
//                         </div>
//                     )}

//                     {/* Intro Text */}
//                     {introText && (
//                         <div className="max-w-4xl mx-auto text-center mb-24">
//                             <p className="text-xl md:text-2xl text-white/80 font-light leading-relaxed">
//                                 {introText}
//                             </p>
//                         </div>
//                     )}

//                     <div className="grid lg:grid-cols-12 gap-12 lg:gap-24">
//                         {/* Left Column - Logo + Services List */}
//                         <div className="lg:col-span-4 space-y-8">
//                             <div className="sticky top-24 space-y-8">
//                                 {/* Brand Logo Glass Card */}
//                                 <motion.div
//                                     initial={{ opacity: 0, y: 15 }}
//                                     whileInView={{ opacity: 1, y: 0 }}
//                                     viewport={{ once: true }}
//                                     transition={{ duration: 0.6 }}
//                                     className="p-5 md:p-6 rounded-3xl bg-white/90 backdrop-blur-xl border border-white/70 shadow-2xl flex items-center gap-4"
//                                 >
//                                     <img
//                                         src={AlKondaLogo}
//                                         alt="AL-KONDA Group Logo"
//                                         className="h-12 md:h-14 w-auto object-contain"
//                                     />
//                                     <span className="text-xs md:text-sm font-semibold tracking-[0.22em] uppercase text-gray-800">
//                                         AL-KONDA GROUP
//                                     </span>
//                                 </motion.div>

//                                 {/* Capabilities Card */}
//                                 <div className="p-8 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-xl shadow-2xl">
//                                     <h3 className="text-2xl font-light mb-8 pb-4 border-b border-white/10 flex items-center gap-3">
//                                         <div className="w-1 h-8 bg-blue-500 rounded-full" />
//                                         {t('buttons.ourCapabilities')}
//                                     </h3>
//                                     <div className="space-y-4">
//                                         {capabilities.map((cap, index) => (
//                                             <motion.div
//                                                 key={index}
//                                                 initial={{ opacity: 0, x: -20 }}
//                                                 whileInView={{ opacity: 1, x: 0 }}
//                                                 viewport={{ once: true }}
//                                                 transition={{ delay: index * 0.05 }}
//                                                 className="flex items-start group cursor-default p-3 rounded-xl hover:bg-white/5 transition-all duration-300"
//                                             >
//                                                 <div className="mt-1 mr-4 p-1 rounded-full bg-blue-500/20 text-blue-400 group-hover:bg-blue-500 group-hover:text-white transition-colors">
//                                                     <CheckCircle2 className="w-4 h-4" />
//                                                 </div>
//                                                 <span className="text-white/70 group-hover:text-white transition-colors text-lg font-light leading-relaxed">
//                                                     {cap}
//                                                 </span>
//                                             </motion.div>
//                                         ))}
//                                     </div>
//                                 </div>

//                                 {/* Contact Card */}
//                                 <div className="p-8 bg-white/5 rounded-3xl border border-white/10 backdrop-blur-xl shadow-2xl">
//                                     <h4 className="text-xl font-medium mb-4">{t('buttons.needCustomSolution')}</h4>
//                                     <p className="text-white/70 text-sm mb-6 leading-relaxed">
//                                         {t('buttons.customSolutionDesc')}
//                                     </p>
//                                     <button
//                                         onClick={() => navigate('/contact')}
//                                         className="w-full py-4 bg-white text-black rounded-xl font-medium hover:bg-gray-100 transition-colors shadow-lg shadow-white/5"
//                                     >
//                                         {t('buttons.getInTouch')}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Right Column - Detailed Content */}
//                         <div className="lg:col-span-8">
//                             <div className="grid gap-8">
//                                 {services &&
//                                     services.map((service, index) => (
//                                         <motion.div
//                                             key={index}
//                                             initial={{ opacity: 0, y: 20 }}
//                                             whileInView={{ opacity: 1, y: 0 }}
//                                             viewport={{ once: true }}
//                                             transition={{ delay: index * 0.1 }}
//                                             className="group relative overflow-hidden rounded-3xl border border-white/20 bg-white/5 backdrop-blur-xl hover:bg-white/10 hover:border-white/30 transition-all duration-500 shadow-2xl min-h-[320px]"
//                                         >
//                                             <div className="flex flex-col md:flex-row h-full">
//                                                 {/* Image Section */}
//                                                 <div className="relative md:w-1/2 overflow-hidden min-h-[280px] md:min-h-full">
//                                                     <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-black/20 to-transparent z-10" />
//                                                     <img
//                                                         src={
//                                                             service.image ||
//                                                             'https://images.unsplash.com/photo-1581094794329-cd2a1fb0e538?w=600&h=400&fit=crop&q=70&auto=format'
//                                                         }
//                                                         alt={service.title}
//                                                         loading="lazy"
//                                                         decoding="async"
//                                                         className="w-full h-full object-cover group-hover:brightness-110 group-hover:blur-[1px] transition-all duration-300 ease-out"
//                                                     />
//                                                 </div>

//                                                 {/* Content Section */}
//                                                 <div className="md:w-1/2 p-8 md:p-10 flex flex-col justify-center bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm">
//                                                     <div className="w-14 h-14 bg-white/15 backdrop-blur-md rounded-2xl flex items-center justify-center mb-6 group-hover:bg-white/25 transition-colors border border-white/10 shadow-lg">
//                                                         <service.icon className="w-7 h-7 text-white" />
//                                                     </div>
//                                                     <h3 className="text-2xl font-medium mb-4 text-white">
//                                                         {service.title}
//                                                     </h3>
//                                                     <p className="text-white/80 leading-relaxed text-lg font-light">
//                                                         {service.description}
//                                                     </p>
//                                                 </div>
//                                             </div>
//                                         </motion.div>
//                                     ))}
//                             </div>

//                             {/* Premium Glassmorphism Workflow Section */}
//                             {workflow && (
//                                 <div className="mt-32">
//                                     <motion.div
//                                         initial={{ opacity: 0, y: 20 }}
//                                         whileInView={{ opacity: 1, y: 0 }}
//                                         viewport={{ once: true }}
//                                         className="text-center mb-16"
//                                     >
//                                         {/* UPDATED HERE: 
//                                           Added conditional check for isRTL. 
//                                           If isRTL is true, it adds:
//                                           1. leading-relaxed (Fixes cut off text)
//                                           2. pb-2 (Adds padding bottom to prevent cut off)
//                                           3. -translate-y-2 (Moves the text UP)
//                                         */}
//                                         <h3 className={`text-4xl md:text-5xl font-light mb-4 bg-gradient-to-r from-white via-white to-white/60 bg-clip-text text-transparent 
//                                             ${isRTL ? 'leading-relaxed pb-2 -translate-y-2' : ''}`}>
//                                             {t('buttons.howWeDeliver')}
//                                         </h3>
//                                         <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto rounded-full" />
//                                     </motion.div>

//                                     <div className="grid md:grid-cols-2 gap-8">
//                                         {workflow.map((step, index) => (
//                                             <motion.div
//                                                 key={index}
//                                                 initial={{ opacity: 0, y: 30 }}
//                                                 whileInView={{ opacity: 1, y: 0 }}
//                                                 viewport={{ once: true }}
//                                                 transition={{ delay: index * 0.15, duration: 0.6 }}
//                                                 whileHover={{ y: -8, scale: 1.02 }}
//                                                 className="group relative"
//                                             >
//                                                 <div className="absolute -top-6 -left-6 z-20">
//                                                     <div className="relative">
//                                                         <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full blur-xl opacity-60 group-hover:opacity-100 transition-opacity duration-500" />
//                                                         <div className="relative w-16 h-16 bg-gradient-to-br from-blue-500/20 to-cyan-500/20 backdrop-blur-xl rounded-full flex items-center justify-center border border-white/20 shadow-2xl">
//                                                             <span className="text-2xl font-bold bg-gradient-to-br from-blue-400 to-cyan-400 bg-clip-text text-transparent">
//                                                                 {step.step}
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                 </div>

//                                                 <div className="relative h-full p-10 pt-12 rounded-3xl overflow-hidden">
//                                                     <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-white/5 to-transparent backdrop-blur-xl" />
//                                                     <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-cyan-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

//                                                     <div className="absolute inset-0 rounded-3xl border border-white/20 group-hover:border-white/30 transition-colors duration-500" />
//                                                     <div className="absolute inset-0 rounded-3xl border border-blue-500/0 group-hover:border-blue-500/20 transition-colors duration-500" />

//                                                     <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:via-white/40 transition-all duration-500" />

//                                                     <div className="relative z-10">
//                                                         <h4 className="text-2xl font-medium mb-4 text-white group-hover:text-white transition-colors duration-300">
//                                                             {step.title}
//                                                         </h4>
//                                                         <p className="text-white/70 group-hover:text-white/90 leading-relaxed text-lg transition-colors duration-300">
//                                                             {step.description}
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </motion.div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             )}

//                             {children}
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </div>
//     )
// }

// export default ServicePageLayout

import { motion, useScroll, useTransform } from 'framer-motion'
import { useState, useEffect, useRef } from 'react'
import { ChevronLeft, ChevronRight, ArrowRight, ArrowLeft, CheckCircle2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LoadingIndicator from './LoadingIndicator'
import '../styles/glassmorphism.css'

// adjust the path if your assets folder is different
import AlKondaLogo from '../assets/al-konda-logo-optimized.webp'

const ServicePageLayout = ({
    title,
    subtitle,
    description,
    backgroundImages,
    services,
    capabilities,
    stats,
    workflow,
    heroSlides,
    introText,
    children
}) => {
    const { t, i18n } = useTranslation()
    const isRTL = i18n.language === 'ar' || i18n.language === 'ku'
    const [currentImageIndex, setCurrentImageIndex] = useState(0)
    const [imagesLoaded, setImagesLoaded] = useState(false)
    const navigate = useNavigate()
    const containerRef = useRef(null)
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ['start start', 'end end']
    })

    const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%'])

    // ✅ OPTIMIZED: Only wait for the FIRST image to load before showing the site
    useEffect(() => {
        if (!backgroundImages || backgroundImages.length === 0) {
            setImagesLoaded(true)
            return
        }

        // 1. Load the first image immediately to unblock the UI
        const firstImage = new Image()
        firstImage.src = backgroundImages[0]

        const handleFirstImageLoad = () => {
            setImagesLoaded(true)

            // 2. Load the rest of the images in the background
            if (backgroundImages.length > 1) {
                backgroundImages.slice(1).forEach(src => {
                    const img = new Image()
                    img.src = src
                })
            }
        }

        firstImage.onload = handleFirstImageLoad
        firstImage.onerror = handleFirstImageLoad // Proceed even if error

        // Fallback safety timeout (in case image hangs)
        const loadingTimeout = setTimeout(() => {
            setImagesLoaded(true)
        }, 2000)

        return () => clearTimeout(loadingTimeout)
    }, [backgroundImages])

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex(prev => (prev + 1) % backgroundImages.length)
        }, 5000)
        return () => clearInterval(interval)
    }, [backgroundImages.length])

    const nextImage = () => {
        setCurrentImageIndex(prev => (prev + 1) % backgroundImages.length)
    }

    const prevImage = () => {
        setCurrentImageIndex(prev => (prev - 1 + backgroundImages.length) % backgroundImages.length)
    }

    return (
        <div
            ref={containerRef}
            className="relative min-h-screen text-white overflow-x-hidden"
        >
            {/* Loading Overlay */}
            {!imagesLoaded && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-50 bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center backdrop-blur-sm"
                >
                    <LoadingIndicator size="large" showText={true} />
                </motion.div>
            )}

            {/* Dynamic Background Layer - takes effect from current hero image */}
            <div className="fixed inset-0 -z-10 bg-black">
                <div
                    className="absolute inset-0 bg-cover bg-center transition-all duration-1000 ease-in-out"
                    style={{
                        backgroundImage: `url(${backgroundImages[currentImageIndex]})`,
                        filter: 'blur(20px) brightness(0.4)',
                        transform: 'scale(1.1)'
                    }}
                />
                {/* Overlays for proper contrast and color neutrality */}
                <div className="absolute inset-0 bg-black/40" />
                <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black" />
            </div>

            {/* Hero Section */}
            <section className="relative h-[100dvh] min-h-[600px] w-full overflow-hidden z-10">
                {/* Background Slider */}
                <motion.div style={{ y }} className="absolute inset-0 w-full h-full">
                    {backgroundImages.map((image, index) => (
                        <motion.div
                            key={index}
                            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                            style={{ backgroundImage: `url(${image})` }}
                            initial={{ opacity: 0, scale: 1.1 }}
                            animate={{
                                opacity: index === currentImageIndex ? 1 : 0,
                                scale: index === currentImageIndex ? 1 : 1.1
                            }}
                            transition={{ duration: 1.5, ease: 'easeInOut' }}
                        />
                    ))}
                    <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
                </motion.div>

                {/* Hero Content */}
                <div className="relative z-20 h-full flex flex-col justify-between">
                    {/* Top Content */}
                    <div className="flex-1 flex items-start pt-32 sm:pt-32 lg:pt-36">
                        <div className="w-full px-6 sm:px-8 lg:px-12 max-w-7xl mx-auto">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: imagesLoaded ? 1 : 0, x: imagesLoaded ? 0 : -50 }}
                                transition={{ duration: 0.8, delay: 0.2 }}
                                className="space-y-6 sm:space-y-8 w-full"
                            >
                                {/* Text Content */}
                                <div className="space-y-6 sm:space-y-8">
                                    {heroSlides ? (
                                        <motion.div
                                            key={currentImageIndex}
                                            initial={{ opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -30 }}
                                            transition={{ duration: 0.8, ease: "easeOut" }}
                                            className="space-y-4 sm:space-y-4"
                                        >
                                            <div className="text-white/80 text-sm min-[390px]:text-base min-[430px]:text-lg sm:text-base font-semibold tracking-[0.15em] uppercase">
                                                {heroSlides[currentImageIndex].subtitle || subtitle}
                                            </div>
                                            <h1 className="text-3xl min-[390px]:text-4xl min-[430px]:text-5xl sm:text-5xl md:text-6xl lg:text-6xl xl:text-7xl font-medium text-white leading-[0.95] tracking-tight">
                                                {heroSlides[currentImageIndex].title || title}
                                            </h1>
                                        </motion.div>
                                    ) : (
                                        <div className="space-y-4 sm:space-y-4">
                                            <div className="text-white/80 text-sm min-[390px]:text-base min-[430px]:text-lg sm:text-base font-semibold tracking-[0.15em] uppercase">
                                                {subtitle}
                                            </div>
                                            <h1 className="text-3xl min-[390px]:text-4xl min-[430px]:text-5xl sm:text-5xl md:text-6xl lg:text-6xl xl:text-7xl font-medium text-white leading-[0.95] tracking-tight">
                                                {title}
                                            </h1>
                                        </div>
                                    )}

                                    <p className="text-base min-[390px]:text-lg min-[430px]:text-xl sm:text-xl md:text-xl lg:text-xl text-white/90 font-normal leading-relaxed max-w-3xl">
                                        {heroSlides ? heroSlides[currentImageIndex].description : description}
                                    </p>
                                </div>
                            </motion.div>
                        </div>
                    </div>

                    {/* Bottom Content */}
                    <div className="pb-16 sm:pb-16 lg:pb-20">
                        <div className="w-full px-6 sm:px-8 lg:px-12 max-w-7xl mx-auto">
                            <motion.div
                                key={heroSlides ? currentImageIndex : 0}
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -30 }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                                className="space-y-6 sm:space-y-6"
                            >
                                {/* CTA Buttons */}
                                <div className="flex flex-wrap gap-4">
                                    <button
                                        onClick={() => document.getElementById('content').scrollIntoView({ behavior: 'smooth' })}
                                        className="group bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] text-white px-8 py-4 sm:px-8 sm:py-4 rounded-full font-medium hover:bg-white/10 transition-all duration-300 flex items-center gap-3 sm:gap-3 text-base min-[390px]:text-lg min-[430px]:text-xl sm:text-base min-h-[56px] sm:min-h-[56px] touch-manipulation"
                                    >
                                        {t('buttons.exploreServices')}
                                        {isRTL ? (
                                            <ArrowLeft className="w-5 h-5 min-[390px]:w-6 min-[390px]:h-6 min-[430px]:w-7 min-[430px]:h-7 sm:w-5 sm:h-5 group-hover:-translate-x-1 transition-transform duration-300" />
                                        ) : (
                                            <ArrowRight className="w-5 h-5 min-[390px]:w-6 min-[390px]:h-6 min-[430px]:w-7 min-[430px]:h-7 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform duration-300" />
                                        )}
                                    </button>
                                    <button
                                        onClick={() => navigate('/services')}
                                        className="bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] text-white px-8 py-4 sm:px-8 sm:py-4 rounded-full font-medium hover:bg-white/10 transition-all duration-300 text-base min-[390px]:text-lg min-[430px]:text-xl sm:text-base min-h-[56px] sm:min-h-[56px] touch-manipulation"
                                    >
                                        {t('buttons.allServices')}
                                    </button>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>

                {/* Slider Controls */}
                <div className={`absolute bottom-12 z-30 flex gap-4 ${isRTL ? 'left-12' : 'right-12'}`}>
                    <button
                        onClick={isRTL ? nextImage : prevImage}
                        className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center hover:bg-white/20 transition-colors"
                    >
                        {isRTL ? <ChevronRight className="w-6 h-6" /> : <ChevronLeft className="w-6 h-6" />}
                    </button>
                    <button
                        onClick={isRTL ? prevImage : nextImage}
                        className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center hover:bg-white/20 transition-colors"
                    >
                        {isRTL ? <ChevronLeft className="w-6 h-6" /> : <ChevronRight className="w-6 h-6" />}
                    </button>
                </div>

                {/* Progress Bar */}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-white/10">
                    <motion.div
                        className="h-full bg-white"
                        initial={{ width: '0%' }}
                        animate={{ width: '100%' }}
                        transition={{ duration: 5, repeat: Infinity, ease: 'linear', key: currentImageIndex }}
                    />
                </div>
            </section>

            {/* Main Content Section */}
            <section id="content" className="relative pt-24 pb-32 px-6 z-10">
                <div className="container mx-auto">
                    {/* Stats Grid */}
                    {stats && (
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-24 border-b border-white/10 pb-12">
                            {stats.map((stat, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: index * 0.1 }}
                                    className="text-center md:text-left"
                                >
                                    <div className="text-4xl md:text-5xl font-light mb-2">{stat.value}</div>
                                    <div className="text-white/60 text-sm uppercase tracking-wider">{stat.label}</div>
                                </motion.div>
                            ))}
                        </div>
                    )}

                    {/* Intro Text */}
                    {introText && (
                        <div className="max-w-4xl mx-auto text-center mb-24">
                            <p className="text-xl md:text-2xl text-white/80 font-light leading-relaxed">
                                {introText}
                            </p>
                        </div>
                    )}

                    <div className="grid lg:grid-cols-12 gap-12 lg:gap-24">
                        {/* Left Column - Logo + Services List */}
                        <div className="lg:col-span-4 space-y-8">
                            <div className="sticky top-24 space-y-8">
                                {/* Brand Logo Glass Card */}
                                <motion.div
                                    initial={{ opacity: 0, y: 15 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6 }}
                                    className="p-5 md:p-6 rounded-3xl bg-white/90 backdrop-blur-xl border border-white/70 shadow-2xl flex items-center gap-4"
                                >
                                    <img
                                        src={AlKondaLogo}
                                        alt="AL-KONDA Group Logo"
                                        loading="eager" // ✅ Force eager load for logo
                                        className="h-12 md:h-14 w-auto object-contain"
                                    />
                                    <span className="text-xs md:text-sm font-semibold tracking-[0.22em] uppercase text-gray-800">
                                        AL-KONDA GROUP
                                    </span>
                                </motion.div>

                                {/* Capabilities Card */}
                                <div className="p-8 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-xl shadow-2xl">
                                    <h3 className="text-2xl font-light mb-8 pb-4 border-b border-white/10 flex items-center gap-3">
                                        <div className="w-1 h-8 bg-blue-500 rounded-full" />
                                        {t('buttons.ourCapabilities')}
                                    </h3>
                                    <div className="space-y-4">
                                        {capabilities.map((cap, index) => (
                                            <motion.div
                                                key={index}
                                                initial={{ opacity: 0, x: -20 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                viewport={{ once: true }}
                                                transition={{ delay: index * 0.05 }}
                                                className="flex items-start group cursor-default p-3 rounded-xl hover:bg-white/5 transition-all duration-300"
                                            >
                                                <div className="mt-1 mr-4 p-1 rounded-full bg-blue-500/20 text-blue-400 group-hover:bg-blue-500 group-hover:text-white transition-colors">
                                                    <CheckCircle2 className="w-4 h-4" />
                                                </div>
                                                <span className="text-white/70 group-hover:text-white transition-colors text-lg font-light leading-relaxed">
                                                    {cap}
                                                </span>
                                            </motion.div>
                                        ))}
                                    </div>
                                </div>

                                {/* Contact Card */}
                                <div className="p-8 bg-white/5 rounded-3xl border border-white/10 backdrop-blur-xl shadow-2xl">
                                    <h4 className="text-xl font-medium mb-4">{t('buttons.needCustomSolution')}</h4>
                                    <p className="text-white/70 text-sm mb-6 leading-relaxed">
                                        {t('buttons.customSolutionDesc')}
                                    </p>
                                    <button
                                        onClick={() => navigate('/contact')}
                                        className="w-full py-4 bg-white text-black rounded-xl font-medium hover:bg-gray-100 transition-colors shadow-lg shadow-white/5"
                                    >
                                        {t('buttons.getInTouch')}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Right Column - Detailed Content */}
                        <div className="lg:col-span-8">
                            <div className="grid gap-8">
                                {services &&
                                    services.map((service, index) => (
                                        <motion.div
                                            key={index}
                                            initial={{ opacity: 0, y: 20 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            viewport={{ once: true }}
                                            transition={{ delay: index * 0.1 }}
                                            className="group relative overflow-hidden rounded-3xl border border-white/20 bg-white/5 backdrop-blur-xl hover:bg-white/10 hover:border-white/30 transition-all duration-500 shadow-2xl min-h-[320px]"
                                        >
                                            <div className="flex flex-col md:flex-row h-full">
                                                {/* Image Section */}
                                                <div className="relative md:w-1/2 overflow-hidden min-h-[280px] md:min-h-full">
                                                    <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-black/20 to-transparent z-10" />
                                                    <img
                                                        src={
                                                            service.image ||
                                                            'https://images.unsplash.com/photo-1581094794329-cd2a1fb0e538?w=600&h=400&fit=crop&q=70&auto=format'
                                                        }
                                                        alt={service.title}
                                                        loading="lazy"      // ✅ ALREADY CORRECT (Keep this)
                                                        decoding="async"    // ✅ ALREADY CORRECT (Keep this)
                                                        className="w-full h-full object-cover group-hover:brightness-110 group-hover:blur-[1px] transition-all duration-300 ease-out"
                                                    />
                                                </div>

                                                {/* Content Section */}
                                                <div className="md:w-1/2 p-8 md:p-10 flex flex-col justify-center bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm">
                                                    <div className="w-14 h-14 bg-white/15 backdrop-blur-md rounded-2xl flex items-center justify-center mb-6 group-hover:bg-white/25 transition-colors border border-white/10 shadow-lg">
                                                        <service.icon className="w-7 h-7 text-white" />
                                                    </div>
                                                    <h3 className="text-2xl font-medium mb-4 text-white">
                                                        {service.title}
                                                    </h3>
                                                    <p className="text-white/80 leading-relaxed text-lg font-light">
                                                        {service.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </motion.div>
                                    ))}
                            </div>

                            {/* Premium Glassmorphism Workflow Section */}
                            {workflow && (
                                <div className="mt-32">
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        className="text-center mb-16"
                                    >
                                        <h3 className={`text-4xl md:text-5xl font-light mb-4 bg-gradient-to-r from-white via-white to-white/60 bg-clip-text text-transparent 
                                            ${isRTL ? 'leading-relaxed pb-2 -translate-y-2' : ''}`}>
                                            {t('buttons.howWeDeliver')}
                                        </h3>
                                        <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto rounded-full" />
                                    </motion.div>

                                    <div className="grid md:grid-cols-2 gap-8">
                                        {workflow.map((step, index) => (
                                            <motion.div
                                                key={index}
                                                initial={{ opacity: 0, y: 30 }}
                                                whileInView={{ opacity: 1, y: 0 }}
                                                viewport={{ once: true }}
                                                transition={{ delay: index * 0.15, duration: 0.6 }}
                                                whileHover={{ y: -8, scale: 1.02 }}
                                                className="group relative"
                                            >
                                                <div className="absolute -top-6 -left-6 z-20">
                                                    <div className="relative">
                                                        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full blur-xl opacity-60 group-hover:opacity-100 transition-opacity duration-500" />
                                                        <div className="relative w-16 h-16 bg-gradient-to-br from-blue-500/20 to-cyan-500/20 backdrop-blur-xl rounded-full flex items-center justify-center border border-white/20 shadow-2xl">
                                                            <span className="text-2xl font-bold bg-gradient-to-br from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                                                                {step.step}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="relative h-full p-10 pt-12 rounded-3xl overflow-hidden">
                                                    <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-white/5 to-transparent backdrop-blur-xl" />
                                                    <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-cyan-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                                                    <div className="absolute inset-0 rounded-3xl border border-white/20 group-hover:border-white/30 transition-colors duration-500" />
                                                    <div className="absolute inset-0 rounded-3xl border border-blue-500/0 group-hover:border-blue-500/20 transition-colors duration-500" />
                                                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:via-white/40 transition-all duration-500" />

                                                    <div className="relative z-10">
                                                        <h4 className="text-2xl font-medium mb-4 text-white group-hover:text-white transition-colors duration-300">
                                                            {step.title}
                                                        </h4>
                                                        <p className="text-white/70 group-hover:text-white/90 leading-relaxed text-lg transition-colors duration-300">
                                                            {step.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            </motion.div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {children}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ServicePageLayout